
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Routes, Route, useParams, useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import './App.css';
import { Analytics } from '@vercel/analytics/react';
import { track } from '@vercel/analytics';
import ReactGA from 'react-ga4';

// Each object includes a unique ID, category, a title, an image URL, and a device type.
const wallpapersData = [
  // Phone Wallpapers
  { id: 204, category: 'paint', title: 'Three color flowers', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760509519/Phone_three_color_flowers_n5muwm.jpg' },
  { id: 205, category: 'paint', title: 'Xi', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759338381/DoubleHappyness_xya4im.jpg' },
  { id: 206, category: 'paint', title: 'Pink Flower', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760767649/Phone_pink_flower_hbnm2x.jpg' },

  { id: 299, category: 'sayings', title: 'Live Very Long', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1767683882/Phone_live_long_sgazhb.jpg' },
  { id: 300, category: 'sayings', title: 'Love Yourself', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759441669/LoveYourself2_ji8yl1.jpg' },
  { id: 301, category: 'sayings', title: 'Lucky', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759441669/Phone_Lucky2_ccrggz.jpg' },
  { id: 302, category: 'sayings', title: 'Romance', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759338382/blue_romance_tlrudk.jpg' },
  { id: 303, category: 'sayings', title: 'Romance2', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759338689/SandyTan_Romance_zkkzym.jpg' },
  { id: 304, category: 'sayings', title: 'Live Forever', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759338381/LiveForever2_tamniq.jpg' },
  { id: 305, category: 'sayings', title: 'Live Forever(no decor)', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759338381/LiveForever_NoDecor_ge1bhq.jpg' },
  { id: 306, category: 'sayings', title: 'Candy or Poison', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759338382/CandyOrPoison_iiyalx.jpg' },
  { id: 307, category: 'sayings', title: 'Muddy Lotus', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759358833/Phone_MuddyLotus_khpxom.jpg' },
  { id: 308, category: 'sayings', title: 'Bitter Melon', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759440451/Phone_BitterMelon2_ayfsq9.jpg' },
  { id: 309, category: 'sayings', title: 'Bitter Melon 2', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759440269/Phone_BitterMelon_jqigrj.jpg' },
  { id: 310, category: 'sayings', title: 'Casino', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759641307/Phone_Casino_qntsub.jpg' },
  { id: 311, category: 'sayings', title: 'Candy or Poison 2', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759992178/phone_candyorpoison2_neh25i.jpg' },
  { id: 312, category: 'sayings', title: 'Pink Flower - You Pay the Price', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760767649/Phone_pink_flower_words_xmikbs.jpg' },


  { id: 1098, category: 'color', title: 'Green Colors', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760938167/Phone_green_colors_xmqxxu.jpg' },
  { id: 1099, category: 'color', title: 'Sandy Tan', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760937617/Phone_sandy_tan_colors_uutszu.jpg' },
  { id: 1100, category: 'color', title: 'Dark Blue', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107093/phonew_darkblue_nlckq8.jpg' },
  { id: 1101, category: 'color', title: 'Yellow Blue', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107093/phonew_yellowblue_pfoeu6.jpg' },
  { id: 1105, category: 'color', title: 'Dark Pink', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107093/phonew_pink00_hkdmxn.jpg' },
  { id: 1106, category: 'color', title: 'Gold Orange', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107093/phonew_goldorange_sftp8t.jpg' },
  { id: 1107, category: 'color', title: 'Green', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107093/phonew_green_va9l4q.jpg' },
  { id: 1108, category: 'color', title: 'Grey Black', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107094/phonew_greyblack_nkqjp8.jpg' },
  { id: 1109, category: 'color', title: 'Yellow Orange', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107094/phonew_yelloworange_crf2fy.jpg' },
  { id: 1110, category: 'color', title: 'Red', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107094/phonew_red01_hxeask.jpg' },
  { id: 1111, category: 'color', title: 'Grey Blue', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107100/phonew_greyblue_uohmis.jpg' },
  { id: 1112, category: 'color', title: 'Yellow', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107100/phonew_yellow_fzsomv.jpg' },
  { id: 1113, category: 'color', title: 'Pink Red', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757107101/phonew_red00_izjcgd.jpg' },

/*   { id: 503, category: 'cartoon', title: 'Cartoon Fruit', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757010944/phonew_fruits01_ou889b.jpg' },
  { id: 504, category: 'cartoon', title: 'Cartoon Candy', device: 'phone', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1757032248/phonew_candies01_vg4c2o.jpg' },
 */
  // Desktop Wallpapers (using a 16:9 aspect ratio)
  { id: 800, category: 'sayings', title: 'Live Very Long', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1767683899/Desktop_live_long_py2jcd.jpg' },
  { id: 801, category: 'paint', title: 'Three color flowers', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760509519/Desktop_three_color_flowers_h5d2dq.jpg' },
  { id: 802, category: 'paint', title: 'Desert', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1758693756/Desktopw_desert_zq94yp.png' },
  { id: 803, category: 'minimalist', title: 'Yellow Dots', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1758693761/Desktopw_dots_yellow_wmge9v.png' },
  //{ id: 804, category: 'minimalist', title: 'Sun Rise', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1758693757/Desktopw_sunrise_wiongv.png' },
  //{ id: 805, category: 'sayings', title: 'Life is Hard', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1758607574/Desktopw_LifeIsHard_ocdeup.png' },
  //{ id: 806, category: 'sayings', title: 'No Elegance', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1758607574/Desktopw_NoElegance_bx4yne.png' },
  { id: 807, category: 'paint', title: 'No Elegance', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759300974/Lotus_alone_wexitq.jpg' },
  { id: 808, category: 'sayings', title: 'No Elegance 2', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759300973/Lotus_saying_yqnsni.jpg' },
  { id: 809, category: 'sayings', title: 'Fruitless', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1759992183/Desktop_fruitless_btvxip.jpg' },
  { id: 810, category: 'paint', title: 'Pink flower', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760077158/Desktop_pink_flower_b8nfu9.jpg' },
  { id: 811, category: 'sayings', title: 'Limited Kindness', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1760250927/Desktop_LimitedKindness_mrnl19.jpg' },
  { id: 812, category: 'paint', title: 'Green Colors', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1761718758/Desktop_green_colors_yksrll.jpg' },
  { id: 813, category: 'sayings', title: 'Hope for Tomorrow', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1766445221/Hope_For_Tomorrow_mws0o0.jpg' },
  { id: 814, category: 'minimalist', title: 'UC Berkeley Blue Dark', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1772125313/UCB_BlueDark_ksdfjf.jpg' },
  { id: 815, category: 'minimalist', title: 'UC Berkeley Rose Dark', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1772125312/UCB_RoseDark_im9ttw.jpg' },
  { id: 816, category: 'minimalist', title: 'UC Berkeley Green Dark', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1772125312/UCB_greendark_wbwypv.jpg' },
  { id: 817, category: 'color', title: 'UC Berkeley Rose Dark - Pure', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1773160888/Pure_UCB_pink._vn3cew.jpg' },
  { id: 818, category: 'color', title: 'UC Berkeley Blue Dark - Pure', device: 'Desktop&Tablet', imageUrl: 'https://res.cloudinary.com/dasdntmsb/image/upload/v1773160905/Pure_UCB_blue_g8nq9c.jpg' },
  ];

const MainContent = ({ wallpapersData }) => {
  const { t } = useTranslation();
  const { device, category } = useParams();

  const selectedDevice = device || 'phone'; // Default to 'phone' if no device in URL
  const selectedCategory = category || 'All'; // Default to 'All' if no category in URL

  const [enlargedImage, setEnlargedImage] = useState(null);
  const [isTipModalOpen, setTipModalOpen] = useState(false);
  const [isContactModalOpen, setContactModalOpen] = useState(false);
  const [isCustomDesignModalOpen, setCustomDesignModalOpen] = useState(false);

  // Dynamically generate a unique list of categories from the data based on the selected device.
  const categories = ['All', ...new Set(wallpapersData.filter(w => w.device === selectedDevice).map(w => w.category))];
  const devices = ['phone', 'Desktop&Tablet'];

  // Filter the wallpapers based on both the selected device and category.
  const filteredWallpapers = wallpapersData.filter(wallpaper =>
    wallpaper.device === selectedDevice &&
    (selectedCategory === 'All' || wallpaper.category === selectedCategory)
  );

  // Function to handle the download of a wallpaper.
  const handleDownload = async (imageUrl, title) => {
    track('Download Wallpaper', { title: title });
    ReactGA.event({
      category: 'Wallpaper',
      action: 'Download',
      label: title
    });
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${title.toLowerCase().replace(/ /g, '-')}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the image:', error);
    }
  };

  const pageTitle = selectedCategory === 'All'
    ? `All ${selectedDevice.charAt(0).toUpperCase() + selectedDevice.slice(1)} Wallpapers | Unique Wallpaper`
    : `${selectedCategory} Wallpapers for ${selectedDevice.charAt(0).toUpperCase() + selectedDevice.slice(1)} | Unique Wallpaper`;

  const pageDescription = selectedCategory === 'All'
    ? `Browse all our unique ${selectedDevice} wallpapers.`
    : `Find the best ${selectedCategory} wallpapers for your ${selectedDevice}.`;

  // Header Component
  const Header = () => {
    const { t } = useTranslation();
    return (
      <header className="header">
        <nav className="header-nav">
          {/* Device Type Navigation */}
          <div className="device-nav">
            {devices.map((dev) => (
              <Link
                key={dev}
                to={`/${dev}`}
                className={`device-btn ${selectedDevice === dev ? 'active' : ''}`}
              >
                {t(dev)}
              </Link>
            ))}
          </div>

          {/* Category Navigation */}
          <ul className="category-nav">
            {categories.map((cat) => (
              <li key={cat}>
                <Link
                  to={`/${selectedDevice}/${cat === 'All' ? '' : cat}`}
                  className={`category-btn ${selectedCategory === cat ? 'active' : ''}`}
                >
                  {t(cat)}
                </Link>
              </li>
            ))}
          </ul>

          <div className="lang-switcher">
            <button onClick={() => i18n.changeLanguage('en')}>English</button>
            <button onClick={() => i18n.changeLanguage('zh')}>中文</button>
          </div>
        </nav>
      </header>
    );
  };

  // Footer Component
  const Footer = () => {
    const { t } = useTranslation();
    return (
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-links">
            <a href="#contact" target="_blank" onClick={(e) => {
              e.preventDefault();
              setContactModalOpen(true);
            }}>
              {t('contact_me')}
            </a>
            <a href="https://buy.stripe.com/5kQeV72cJ0Cl4i39iDdwc00" target="_blank" rel="noopener noreferrer" style={{ textAlign: 'center', textDecoration: 'none' }}>
              {t('tip_me')}
            </a>
            <a href="#custom-design" target="_blank" onClick={(e) => {
              e.preventDefault();
              setCustomDesignModalOpen(true);
            }}>
              {t('order_custom_design')}
            </a>
          </div>
          <p className="copyright">&copy; 2025 - {new Date().getFullYear()} {t('copyright')}</p>
          <div className="social-links">
          </div>
        </div>
      </footer>
    );
  };

  return (
    <div className="app-container">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Helmet>
      <Header />

      <main className="main-content">
        {/* Enlarged Image Modal */}
        {enlargedImage && (
          <div className="image-modal-overlay" onClick={() => setEnlargedImage(null)}>
            <div className="image-modal-content">
              <img src={enlargedImage} alt="Enlarged wallpaper" className="enlarged-image" />
              <button className="close-modal-btn" aria-label="Close enlarged view">&times;</button>
            </div>
          </div>
        )}

        {/* Contact Me Modal */}
        {isContactModalOpen && (
          <div className="contact-modal-overlay" onClick={() => setContactModalOpen(false)}>
            <div className="contact-modal-content" onClick={e => e.stopPropagation()}>
              <button className="close-modal-btn" onClick={() => setContactModalOpen(false)}>&times;</button>
              <h3>{t('contact_me')}</h3>
              <p>{t('contact_me_description')}</p>
              {/* The action URL below should point to YOUR unique Formspree endpoint */}
              <form action="https://formspree.io/f/mrbajdoq" method="POST" className="contact-form">
                <label htmlFor="email">{t('your_email')}</label>
                <input type="email" id="email" name="email" required />

                <label htmlFor="message">{t('message')}</label>
                <textarea id="message" name="message" rows="6" required></textarea>

                <button type="submit" className="submit-btn">{t('send_message')}</button>
              </form>
            </div>
          </div>
        )}

        {/* Custom Design Modal */}
        {isCustomDesignModalOpen && (
          <div className="contact-modal-overlay" onClick={() => setCustomDesignModalOpen(false)}>
            <div className="contact-modal-content" onClick={e => e.stopPropagation()}>
              <button className="close-modal-btn" onClick={() => setCustomDesignModalOpen(false)}>&times;</button>
              <h3>{t('order_custom_design')}</h3>
              <p>{t('order_custom_design_description')}</p>
              {/* This form also points to your Formspree endpoint. */}
              <form action="https://formspree.io/f/mrbajdoq" method="POST" className="contact-form">
                <input type="hidden" name="_subject" value="New Custom Design Request!" />
                <label htmlFor="custom-email">{t('your_email')}</label>
                <input type="email" id="custom-email" name="email" required />

                <label htmlFor="custom-message">{t('your_request')}</label>
                <textarea id="custom-message" name="message" rows="6" placeholder="e.g., A desktop wallpaper with a minimalist cat, using pastel colors." required></textarea>

                <button type="submit" className="submit-btn">{t('submit_request')}</button>
              </form>
            </div>
          </div>
        )}

        {/* Tip Me Modal */}
        {isTipModalOpen && (
          <div className="contact-modal-overlay" onClick={() => setTipModalOpen(false)}>
            <div className="contact-modal-content" onClick={e => e.stopPropagation()}>
              <button className="close-modal-btn" onClick={() => setTipModalOpen(false)}>&times;</button>
              <h3>{t('tip_me')}</h3>
              <div className="payment-option">
                <p>{t('tip_me_description')}</p>
                <a href="https://buy.stripe.com/5kQeV72cJ0Cl4i39iDdwc00" target="_blank" rel="noopener noreferrer" className="submit-btn" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  {t('tip_with_stripe')}
                </a>
              </div>
            </div>
          </div>
        )}

        <style>{`

        `}</style>

        <section className="hero-section">
          <h2 className="hero-title">
            {t('unique_wallpapers')}
          </h2>
          <p className="hero-subtitle">
            {t('discover_wallpapers')}
          </p>
        </section>

        <section className="wallpaper-gallery">
          {filteredWallpapers.map((wallpaper) => (
            <div
              key={wallpaper.id}
              className="wallpaper-card"
              onClick={() => {
                setEnlargedImage(wallpaper.imageUrl);
                ReactGA.event({
                  category: 'Wallpaper',
                  action: 'Enlarge',
                  label: wallpaper.title
                });
              }}
            >
              <img
                src={wallpaper.imageUrl}
                alt={wallpaper.title}
                className="wallpaper-image"
              />
              <div className="card-overlay">
                <div className="card-details">
                  <span className="wallpaper-title">{wallpaper.title}</span>
                  <span className="wallpaper-category">{t(wallpaper.category)}</span>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the card's onClick from firing
                    handleDownload(wallpaper.imageUrl, wallpaper.title);
                  }}
                  className="download-btn"
                  aria-label="Download"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
};

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ReactGA.initialize('G-6MN3BJ1TXW');
    // Redirect to a default route if no device is specified in the URL
    if (window.location.pathname === '/') {
      navigate('/phone');
    }
  }, [navigate]);

  return (
    <>
      <Routes>
        <Route path="/" element={<MainContent wallpapersData={wallpapersData} />} />
        <Route path="/:device" element={<MainContent wallpapersData={wallpapersData} />} />
        <Route path="/:device/:category" element={<MainContent wallpapersData={wallpapersData} />} />
      </Routes>
      <Analytics />
    </>
  );
};

export default App;
